import { useLocation, Navigate } from "react-router-dom";
import { parseIdToken } from "../../utils/Helper";
import { getNewIdToken } from "../../utils/CognitoAuth";
import { setNewTokens, logout } from "../../features/authSlice";
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';

const RequireAuth = ({ children }) => {

    const dispatch = useDispatch();
    const { isAuthenticated, idToken, refreshToken, refreshTokenExp } = useSelector(state => state.auth);
    const location = useLocation();
    const [isRefreshing, setIsRefreshing] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const refreshTokens = async () => {
            if (isRefreshing) return; // Prevent multiple simultaneous refresh attempts

            try {
                const idTokenExpired = checkIdTokenExpiration(idToken);

                const refreshTokenExpired = checkRefreshTokenExpiration(refreshTokenExp);

                if (refreshTokenExpired) {
                    dispatch(logout());
                    return;
                }

                if (idTokenExpired) {
                    setIsRefreshing(true);
                    setError(null);

                    const { IdToken, AccessToken } = await getNewIdToken(refreshToken);
                    dispatch(setNewTokens({ IdToken, AccessToken }));
                }
            } catch (error) {
                setError(error.message);
                dispatch(logout());
            } finally {
                setIsRefreshing(false);
            }
        };

        const intervalId = setInterval(refreshTokens, 60000);
        refreshTokens(); // Initial check

        return () => clearInterval(intervalId);
    }, [idToken, refreshToken, refreshTokenExp, dispatch, isRefreshing]);

    if (error) {
        return <div>Error: {error}</div>;
    }

    // if (!isAuthenticated && !isRefreshing) {
    //     return <Navigate to="/login" state={{ from: location }} replace />;
    // }

    const idTokenExpired = checkIdTokenExpiration(idToken);
    const refreshTokenExpired = checkRefreshTokenExpiration(refreshTokenExp);

    if (refreshTokenExpired || (!refreshToken && idTokenExpired) || (!isAuthenticated && !isRefreshing)) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }


    if (isRefreshing) {
        return <div>Loading...</div>;
    }

    return children;
};

export default RequireAuth;

const checkRefreshTokenExpiration = (refreshTokenExp) => {
    if (!refreshTokenExp) return true;
    return refreshTokenExp - Date.now() < 0;
};

const checkIdTokenExpiration = (idToken) => {
    if (!idToken) return true;

    const idTokenParsed = parseIdToken(idToken);
    const exp = idTokenParsed.exp;         // Token expiration timestamp (in seconds)
    const currentTime = Math.floor(Date.now() / 1000); // Current time (in seconds)
    const bufferTime = 120;                // Buffer time (2 minutes in seconds)

    return (exp - currentTime) <= bufferTime;
};